/* global axios */
import ApiClient from './ApiClient';

class HelpCenterSearchAPI extends ApiClient {
  constructor() {
    super('help_center/embedding_config', {
      accountScoped: true,
      apiVersion: 'v2',
    });
  }

  getConfig() {
    return axios.get(this.url);
  }

  saveConfig(data) {
    return axios.post(this.url, { embedding_config: data });
  }

  deleteConfig() {
    return axios.delete(this.url);
  }

  testConfig(data) {
    return axios.post(`${this.url}/test`, { embedding_config: data });
  }

  reindex() {
    return axios.post(`${this.url}/reindex`);
  }

  getStatus() {
    return axios.get(`${this.url}/status`);
  }

  getKnowledgeStats() {
    return axios.get(
      this.url.replace('help_center/embedding_config', 'ai/knowledge/stats')
    );
  }

  importFile({ file, collection, brand }) {
    const formData = new FormData();
    formData.append('file', file);
    if (collection) formData.append('collection', collection);
    if (brand) formData.append('brand', brand);
    return axios.post(
      this.url.replace('help_center/embedding_config', 'ai/knowledge/import'),
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  }

  getPortals() {
    return axios.get(this.url.replace('embedding_config', 'portals'));
  }

  updatePortal(id, data) {
    return axios.patch(
      `${this.url.replace('embedding_config', 'portals')}/${id}`,
      { portal: data }
    );
  }
}

export default new HelpCenterSearchAPI();
